import React, { useState,useEffect } from 'react';
import search_icon from '../../assets/images/search_icon.png';
import brownfilter_icon from '../../assets/images/brownfilter_icon.png';
import edit_icon from '../../assets/images/edit_icon.png';                    
import delete_icon from '../../assets/images/delete_icon.png';
import Addproduct from '../Addproduct';
import NewProductPage from '../NewProductPage';
import { DeleteProduct, GetAllProducts,GetProductAndCategoryCounts } from '../../Services/ProductService';
import { GetAllCategories,DeleteCategory } from '../../Services/CategoryService';
import {getImageUrl, handleImageError} from '../../utils/imageUtils'
import productImage from '../../assets/images/our-product.png';
import AddCustomProduct from '../AddCustomProduct';
import DeleteConfirmModal from '../DeleteConfirmModal';

export default function Products() {
  const [activeTab, setActiveTab] = useState('products');
  const [showPopup, setShowPopup] = useState(false);
  const [showCustomProductPopup, setShowCustomProductPopup] = useState(false);
  const [showCategoryPopup, setShowCategoryPopup] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [tabCounts, setTabCounts] = useState({ products: 0, category: 0, vegetables: 0 });
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteType, setDeleteType] = useState(""); // "product" | "category"

  const loadData = async (searchTerm = "") => {
    try {
      setAllProducts([]); 
      const params = {};
      if (searchTerm) params.filter = searchTerm;
      if (selectedCategory) params.categoryIds = selectedCategory;
      if(activeTab === 'products') {
        const userRole = localStorage.getItem("userRole");
        const vendorId = localStorage.getItem("userId");
        if (userRole === "vendor" && vendorId) {
          params.vendorId = vendorId;
        }
        const res = await GetAllProducts(params);
        if (res?.status) {
          setAllProducts(res.data || []);
        }
      } else if(activeTab === 'category') {
        const res = await GetAllCategories(params);
        if (res?.status) {
          setAllProducts(res.data || []);
        }
      }
    } catch (err) {
      console.error("Error loading products/categories:", err);
    }
  };

  useEffect(() => {
    fetchProductAndCategoryCounts();
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await GetAllCategories();
      if (res?.status) setCategories(res.data || []);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  const fetchProductAndCategoryCounts = async () => {
    try {
      const userRole = localStorage.getItem("userRole");
      const vendorId = localStorage.getItem("userId");
      const params = {};
      if (userRole === "vendor" && vendorId) {
        params.vendorId = vendorId;
      }
      const res =  await GetProductAndCategoryCounts(params);
      if (res?.status) {
        setTabCounts({
          products: res.data.productCount || 0,
          category: res.data.categoryCount || 0
        });
      } else {
        console.error("Failed to fetch product and category counts:", res.message);
      }
    } catch (err) {
      console.error("Error fetching counts:", err);
    }
  };

      const handleDelete = (id, type) => {
        setDeleteId(id);
        setDeleteType(type);      // product OR category
        setShowDelete(true);      // popup open
      };

      const confirmDelete = async () => {
        let response = null;

        if (deleteType === "Product") {
            response = await DeleteProduct(deleteId);
        } else if (deleteType === "Category") {
            response = await DeleteCategory(deleteId);
        }

        if (response?.status) {
            loadData();
            setShowDelete(false);
            setDeleteId(null);
            setDeleteType("");
        } else {
            alert("Failed to delete. Please try again.");
        }
      };

      useEffect(() => {
        loadData(searchTerm);
      }, [activeTab, searchTerm, selectedCategory]);
  
  const getAddButtonText = () => {
    switch (activeTab) {
      case 'products':
        return '+ ADD PRODUCT';
      case 'category':
        return '+ ADD CATEGORY';
      case 'vegetables':
        return '+ ADD PRODUCT';
      default:
        return '+ ADD ITEM';
    }
  };


  const getTableHeaders = () => {
    if (activeTab === 'category' || activeTab === 'vegetables') {
      return (
        <tr>
          <th>Name</th>
          {/* <th>Parent Category</th> */}
          <th>Description</th>
          <th>Display Order</th>
          {/* <th>Publish Status</th> */}
          <th>Action</th>
        </tr>
      );
    } else {
      return (
        <tr>
          <th>Name</th>
          <th>Description</th>
          <th>Price</th>
          <th>Category</th>
          {/* <th>Publish Status</th> */}
          <th>Action</th>
        </tr>
      );
    }
  };

  
  const renderTableBody = () => {
    if (allProducts.length === 0) {
      return (
        <tr>
          <td colSpan={6} className="no-products text-center">
            No {activeTab} available.
          </td>
        </tr>
      );
    }

    return allProducts.map((item) => {
      if (activeTab === 'category' || activeTab === 'vegetables') {
        return (
          <tr key={item.id}>
            <td>{item.name}</td>
            {/* <td>{item.parentCategory || 'N/A'}</td> */}
            <td className="description-cell">{item.description}</td>
            <td>{item.displayOrder}</td>
            {/* <td>
              <span className={item.isPublished ? 'status-published' : 'status-draft'}>
                {item.isPublished ? 'Published' : 'Draft'}
              </span>
            </td> */}
            <td className="action-icon">
              <img
                src={edit_icon}
                alt="Edit"
                title={`Edit ${activeTab === 'category' ? 'Category' : 'Vegetable'}`}
                className="edit-icon"
                style={{ cursor: 'pointer', marginRight: '10px' }}
                onClick={() =>{ setSelectedItem(item); setShowCategoryPopup(true);}}
              />
              <img
                src={delete_icon}
                alt="Delete"
                title={`Delete ${activeTab === 'category' ? 'Category' : 'Vegetable'}`}
                className="delete-icon"
                style={{ cursor: 'pointer' }}
                onClick={() => handleDelete(item.id, "Category")}
              />
            </td>
          </tr>
        );
      }

      
      return (
        <tr key={item.id}>
          <td>
            <div className="customer-info">
              <img src={getImageUrl(item.path, productImage)} onError={(e) => handleImageError(e, productImage)} alt={item.name} className="customer-img" />
              <span>{item.name}</span>
            </div>
          </td>
          <td className="description-cell">{item.description}</td>
          <td>{item.price === 'N/A' ? 'N/A' : `₹ ${item.price}`}</td>
          <td>{item.categoryName}</td>
          {/* <td>
            <span className={item.isPublished ? 'status-published' : 'status-draft'}>
              {item.isPublished ? 'Published' : 'Draft'}
            </span>
          </td> */}
          <td className="action-icon">
            <img
              src={edit_icon}
              alt="Edit Product"
              title="Edit Product"
              className="edit-icon"
              style={{ cursor: 'pointer', marginRight: '10px' }}
              onClick={() =>{ setSelectedItem(item); item.isCustomProduct ? setShowCustomProductPopup(true) : setShowPopup(true);}}
            />
            <img
              src={delete_icon}
              alt="Delete Product"
              title="Delete Product"
              className="delete-icon"
              style={{ cursor: 'pointer' }}
              onClick={() => handleDelete(item.id, "Product")}
            />
          </td>
        </tr>
      );
    });
  };

  return (
    <div className="dashboard mt-5">
      
      <div className="d-flex align-items-center mt-4 mb-5">
        <div>
          <h2>Products</h2>
        </div>
        {(activeTab === 'products') && (
        <button className="add-product-btn ms-auto mr_20" onClick={() => {
          setSelectedItem(null);
          setShowCustomProductPopup(true);
        }}>+ Add Custom Product</button>)}
        <button className={`add-product-btn ${
            activeTab === 'category' ? 'ms-auto mr_20' : ''
          }`} onClick={() => {
          setSelectedItem(null);
          if (activeTab === 'products') {
            setShowPopup(true);
          } else {
            setShowCategoryPopup(true);
          }
        }}>
          {getAddButtonText()}
        </button>
      </div>

      
      <div className="order-list mt-5">
        <div className="order-header" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
          
          <div className="tabs">
            <button
              className={activeTab === 'products' ? 'active' : ''}
              onClick={() => setActiveTab('products')}
            >
              Products ({tabCounts.products || 0})
            </button>
            <button
              className={activeTab === 'category' ? 'active' : ''}
              onClick={() => setActiveTab('category')}
            >
              Category ({tabCounts.category || 0})
            </button>
            {/* <button
              className={activeTab === 'vegetables' ? 'active' : ''}
              onClick={() => setActiveTab('vegetables')}
            >
              Vegetables ({allProducts.length})
            </button> */}
          </div>

          
          <div className="search-tools">
            <div className="search-wrapper">
              <input
                type="search"
                value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                placeholder={`Search ${activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}`}
              />
              <div className="icons">
                <img src={search_icon} alt="Search" className="search-icon" />
                <img 
                  src={brownfilter_icon} 
                  alt="Filter" 
                  className="filter-icon" 
                />
              </div>
            </div>
          </div>

            {(activeTab === "products" || activeTab === "category") && (
              <div className="form-group mb-0">
                <select className="category-filter-select"
                  value={selectedCategory}
                  onChange={(e) => {
                    setSelectedCategory(e.target.value);
                  }}
                >
                  <option value="">All Categories</option>
                  {categories.map(cat => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

        </div>

        
        <div className="order-table-wrapper">
           <table>
            <thead>{getTableHeaders()}</thead>
            <tbody >{renderTableBody()}</tbody>
          </table>
        </div>
      </div>

      {/* Popup components */}
      {showPopup && <Addproduct onClose={() =>{ setShowPopup(false); setSelectedItem(null); loadData();}} product={selectedItem}/>}

      {showCustomProductPopup && <AddCustomProduct onClose={() =>{ setShowCustomProductPopup(false); setSelectedItem(null); loadData();}} product={selectedItem}/>}

      {showCategoryPopup && <NewProductPage onClose={() =>{ setShowCategoryPopup(false); setSelectedItem(null); loadData(); }} category={selectedItem} />}

      {/* Delete Popup */}
      <DeleteConfirmModal show={showDelete} itemName={deleteType} onClose={() => setShowDelete(false)} onConfirm={confirmDelete}/>
    </div>
  );
}
